import React from "react";
import { Col, Content, Grid, Row } from "rsuite";
import Dashboard from "../../@Components/Dashboard";
import Domains from "../../@Components/Common/Domains";

const DomainsPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <Domains />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default DomainsPage;
